import * as React from 'react';
import { Route, Switch } from 'react-router-dom';

import { NothingToSee } from 'components/shared';
import MenuDetails from 'components/menu/MenusPage/components/MenuDetails';
import { MenusPage } from 'components/menu/MenusPage';
import RestaurantInformation from 'components/restaurantInformation';
import Closings from 'components/restaurantInformation/closings';
import Transactions from 'components/restaurantInformation/transactions';
import { OrdersPage } from 'components/orders';
import Home from 'components/home';
import Reservations from 'components/reservations';
import NewReservationPage from 'components/reservations/NewReservationPage';
import ProcessRequestPage from 'components/reservations/ProcessRequestPage';
import EditReservationPage from 'components/reservations/EditReservationPage';
import { RESERVATION_POSITIONS } from 'helpers/reservationHelper';
import { RestaurantUsersPage } from 'components/restaurants/restaurantUsersPage/RestaurantUsersPage';
import { CustomerManagementPage } from 'components/restaurants/customerManagementPage/CustomerManagementPage';
import Finance from 'components/restaurantInformation/finance';
import Callback from 'components/callback/Callback';
import silentRenew from 'components/silent-renew';
import Ingredients from '../components/ingredients';
import StockPage from 'components/restaurantInformation/stock';
import PositionRoute from './components/positionRoute';
import { Positions } from 'constants/enums';
import VouchersPage from 'components/restaurantInformation/vouchers';
import TableMapsPage from 'components/tableMaps/TableMapsPage';
import CreateTableMapWizard from 'components/tableMaps/CreateTableMapWizard';
import TableMapDetailsPage from 'components/tableMaps/TableMapDetailsPage';

export const RestaurantOwnerRoute: React.FC<{}> = () => {
    return (
        <Switch>
            <Route exact path="/" component={Home} />
            <Route exact path="/orders" component={OrdersPage} />
            <Route exact path="/menu" component={MenusPage} />
            <Route exact path="/menu/:id" component={MenuDetails} />
            <Route exact path="/ingredients" component={Ingredients} />
            <Route exact path="/users" component={RestaurantUsersPage} />
            <Route exact path="/customers" component={CustomerManagementPage} />
            <Route exact path="/restaurantInformation" component={RestaurantInformation} />
            <Route exact path="/finance" component={Finance} />
            <Route exact path="/callback" component={Callback} />
            <Route exact path="/silentRenew" component={silentRenew} />
            <Route exact path="/closings" component={Closings} />
            <Route exact path="/transactions" component={Transactions} />
            <Route exact path="/vouchers" component={VouchersPage} />
            <PositionRoute
                exact
                path="/reservations"
                positions={RESERVATION_POSITIONS}
                component={Reservations}
            />
            <PositionRoute
                exact
                path="/reservations/new"
                positions={RESERVATION_POSITIONS}
                component={NewReservationPage}
            />
            <PositionRoute
                exact
                path="/reservations/requests/:id/process"
                positions={RESERVATION_POSITIONS}
                component={ProcessRequestPage}
            />
            <PositionRoute
                exact
                path="/reservations/:id/edit"
                positions={RESERVATION_POSITIONS}
                component={EditReservationPage}
            />
            <PositionRoute
                exact
                path="/stock"
                positions={[Positions.MANAGER]}
                component={StockPage}
            />
            <PositionRoute
                exact
                path="/table-maps"
                positions={[Positions.MANAGER]}
                component={TableMapsPage}
            />
            <PositionRoute
                exact
                path="/table-maps/create"
                positions={[Positions.MANAGER]}
                component={CreateTableMapWizard}
            />
            <PositionRoute
                exact
                path="/table-maps/:id/edit"
                positions={[Positions.MANAGER]}
                component={CreateTableMapWizard}
            />
            <PositionRoute
                exact
                path="/table-maps/:id"
                positions={[Positions.MANAGER]}
                component={TableMapDetailsPage}
            />
            <Route component={NothingToSee} />
        </Switch>
    );
};
